export default "__VITE_ASSET__CqdMH5XH__"